import { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { NavLink } from '../../../node_modules/react-router-dom/dist/index';
import { GetSession, RemoveSession } from '../../EnvConfig/env_config';
import { setOpen } from '../../Redux/Services/headerSlice';
import { ApiCall, FindTranslatedKey } from '../CommonComponents/CustomHooks';

const Sidebar = () => {
    const { lang } = useSelector(state => state.lang)
    const [menus, setMenus] = useState([]);
    const dispatch = useDispatch()
    const { open } = useSelector((state) => state.header);
    const getSidebar = async () => {
        const Token = await GetSession('cookies', 'token');
        let LoginUserCode = await GetSession('cookies', 'loginUserCode');
        let UserName = await GetSession('cookies', 'userName');
        let SearchText = ''

        if (!Token) {
            RemoveSession('cookies', 'token')
            RemoveSession('cookies', 'loginUserCode')
            RemoveSession('cookies', 'userName')
        } else {
            if (typeof LoginUserCode !== 'string') {
                LoginUserCode = String(LoginUserCode);
            }
            const data = {
                UserName: UserName,
                SearchText: SearchText
            };
            let res = await ApiCall(`/api/User/GetMenu`, data)
            if (res.status === 'SUCCESS') {
                setMenus(res.getMenu)
            }
            else if (res.message !== "") {
                toast.error(res.message, {
                    position: 'top-center'
                })
            }
        }
    }

    useEffect(() => {
        function handleresize() {
            if (window.innerWidth < 1200) {
                dispatch(setOpen(false));
            } else {
                dispatch(setOpen(true));
            }
        }
        handleresize();
        window.addEventListener("resize", handleresize);
        return () => window.addEventListener("resize", handleresize);
    }, [])

    useEffect(() => {
        getSidebar()
    }, []);

    return (
        <>
            <aside id="sidebar" className="sidebar" style={open ? {} : { left: "-250px" }}>
                <ul className="sidebar-nav" id="sidebar-nav">
                    {menus !== null &&
                        (menus.map((menu, index) => (
                            <li className="nav-item" style={{ cursor: "pointer" }} key={index}>
                                {menu.getSubMenu !== null ?
                                    (
                                        <>
                                            <div
                                                className={`nav-link collapsed cursor-pointer`}
                                                data-bs-target={`#${(menu.menuText).replaceAll(' ', '').replaceAll('&', '')}`}
                                                data-bs-toggle="collapse"
                                            >
                                                <i className={menu.cssClass} />
                                                {/*<span>{menu.menuText}</span>*/}
                                                <span>{FindTranslatedKey(menu.menuText)}</span>
                                                <i className="bi bi-chevron-down ms-auto" />
                                            </div>

                                            <ul
                                                id={`${(menu.menuText).replaceAll(' ', '').replaceAll('&', '')}`}
                                                className={`nav-content collapse open sidebar-submenu ${menu.getSubMenu[0].mpageID === localStorage.getItem('ID') ? 'show' : ''}`}
                                                data-bs-parent="#sidebar-nav"
                                            >
                                                {menu.getSubMenu.map((subMenu, i) => (
                                                    <li key={i} className='mx-2 my-1' onClick={() => localStorage.setItem('ID', subMenu.mpageID)}>
                                                        <NavLink to={`/${(subMenu.pageUrl)}`}
                                                            id={subMenu.pageID}>
                                                            <i className={subMenu.cssClass} />
                                                            {/*   <span>{(subMenu.menuText).trim()}</span>*/}
                                                            <span>{FindTranslatedKey(subMenu.menuText).trim()}</span>
                                                        </NavLink>
                                                    </li>
                                                ))}
                                            </ul>
                                        </>
                                    ) : (
                                        <NavLink
                                            className="nav-link collapsed"
                                            cursor-pointer
                                            key={index}
                                            to={`/${menu.pageUrl}`}
                                        >
                                            <i className={menu.cssClass} />
                                            {/*   <span>{menu.menuText}</span>*/}
                                            <span>{FindTranslatedKey(menu.menuText)}</span>
                                            <i className="bi bi-chevron-down ms-auto" />
                                        </NavLink>)}
                            </li>
                        )))}
                </ul>
            </aside>
        </>
    )
}
export default memo(Sidebar)


